import React from 'react'

const About = () => {
    return (
        <div className="page">
            <h1 className="page-title">
                about
            </h1>
        </div>
    )
}

export default About